module.exports = __webpack_public_path__ + "static/media/lupabanner_sm1.2c4d5b50.png";